import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 2.965c0-.737.506-1.013 1.128-.62l11.741 7.442c.623.394.622 1.035 0 1.429l-11.741 7.44c-.623.395-1.128.12-1.128-.618V2.965z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);